import { ChartField } from 'src/app/types/chart.model'
import { NUM_MATCHED_ITEMS_VALUE_FIELD } from 'src/app/types/constants'
import { CHILD_JOB_FIELDS } from './job-lookup.model'

// processed = strings converted to dates
export interface ProcessedExtra {
  // More fields are available on OrderLineExtraDto; keep this type to app-used fields only.
  id: number
  jobNumber: string | null

  costCentreDescription: string | null
  createDate: Date
  description: string | null
  division: string | null
  stage: string | null
  modifiedDate: Date
  invoiceVendorName: string | null
  poNumber: string | null
  siteManager: string | null
  varianceCodeDescription: string | null
  varianceReasonDescription: string | null
  varianceTotal: number | null
  vendorName: string | null
}

const EXTRAS_CORE_FIELDS: ChartField[] = [
  {
    dataField: 'description',
    displayName: 'Description',
    dataType: 'string',
  },
  {
    dataField: 'varianceReasonDescription',
    displayName: 'Variance Reason Description',
    dataType: 'string',
  },
  {
    dataField: 'varianceCodeDescription',
    displayName: 'Variance Code Description',
    dataType: 'string',
  },
  {
    dataField: 'costCentreDescription',
    displayName: 'Cost Centre Description',
    dataType: 'string',
  },
  {
    dataField: 'poNumber',
    displayName: 'PO Number',
    dataType: 'string',
  },
  {
    dataField: 'vendorName',
    displayName: 'Vendor Name',
    dataType: 'string',
  },
  {
    dataField: 'invoiceVendorName',
    displayName: 'Invoice Vendor Name',
    dataType: 'string',
  },
  {
    dataField: 'varianceTotal',
    displayName: 'Variance Total',
    dataType: 'number',
    numberPrefix: '$',
  },
  {
    dataField: 'createDate',
    displayName: 'Create Date',
    dataType: 'date',
  },
  {
    dataField: 'modifiedDate',
    displayName: 'Modified Date',
    dataType: 'date',
  },
]

export const EXTRAS_ALL_FIELDS: ChartField[] = [...EXTRAS_CORE_FIELDS, ...CHILD_JOB_FIELDS]

export const EXTRAS_FILTER_FIELDS: ChartField[] = EXTRAS_ALL_FIELDS

export const EXTRAS_DATE_FILTER_FIELDS: ChartField[] = EXTRAS_ALL_FIELDS.filter(
  (jtf) => jtf.dataType === 'date'
)

export const EXTRAS_ARGUMENT_FIELDS: ChartField[] = [
  ...EXTRAS_CORE_FIELDS.filter(
    (jtf) => jtf.dataType === 'string' || jtf.dataType === 'date' || jtf.dataType === 'number'
  ),
  ...CHILD_JOB_FIELDS,
]

export const EXTRAS_VALUE_FIELDS: ChartField[] = [
  ...EXTRAS_ALL_FIELDS.filter((jtf) => jtf.dataType === 'number'),
  NUM_MATCHED_ITEMS_VALUE_FIELD,
]

export const EXTRAS_SERIES_GROUP_FIELDS: ChartField[] = EXTRAS_ALL_FIELDS.filter(
  (jtf) => jtf.dataType === 'string' || jtf.dataType === 'boolean'
)
